export default function breakLines(string) {
  return string.replace(/(\r\n|\n|\r)/gm, '<br>');
}
